export class RegexpUtils {
    public static readonly EMAIL_REGEXP: RegExp = new RegExp(
        "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?"
    );
    public static readonly QNUMBER_REGEXP: RegExp = new RegExp('\\bq[0-9a-zA-Z]{6}\\b');

    public static verifyEmailFormat(emailString: string): boolean {
        return this.EMAIL_REGEXP.test(emailString);
    }

    public static verifyQNumberFormat(qNumberString: string): QNumberRegExpOutcomes {
        if (this.QNUMBER_REGEXP.test(qNumberString)) {
            return QNumberRegExpOutcomes.Valid;
        }

        if (qNumberString[0] !== 'q' && qNumberString[0] !== 'Q') {
            return QNumberRegExpOutcomes.WrongFirstChar;
        }
        if (qNumberString.length != 7) {
            return QNumberRegExpOutcomes.WrongLength;
        }
        return QNumberRegExpOutcomes.InvalidChar;
    }
}

export const FILTER_WILDCARD = '*';

export enum QNumberRegExpOutcomes {
    WrongLength = 'ERROR.APP_WARN_QNUMBER_MUST_HAVE_7_CHAR.TXT',
    InvalidChar = 'ERROR.APP_WARN_QNUMBER_CONTAINS_ILLEGAL_CHAR.TXT',
    WrongFirstChar = 'ERROR.APP_WARN_QNUMBER_MUST_START_WITH_Q.TXT',
    Valid = ''
}
